import { createPinia, setActivePinia } from 'pinia';

/**
 * The one pinia instance, and the app's only store since vuex was removed.
 *
 * `app.use(pinia)` in vue/createApp.js is what gives components `this.$pinia`, but it is not
 * what makes a store usable: half the callers here are not components and do not wait for a
 * mount. CurrentUser builds its reader from module scope - vue/filters/CustomTerm and raven
 * do it while modules are still loading - so the instance is made active as this module
 * loads, and every store module imports it to guarantee that ordering.
 */
const pinia = createPinia();
setActivePinia(pinia);

export default pinia;
